import React from 'react';

import Chip from '@material-ui/core/Chip';

import { allPossibleStatuses, statusDisplay } from '../../config/application-status-config';

type InputProps = {
  keyPrefix: string;
  selectedStatuses: Array<ApplicationStatus>;
  onRemove?: (removedStatus: ApplicationStatus) => () => void;
};

export const StatusChangeChips = ({ keyPrefix, selectedStatuses, onRemove }: InputProps) => {
  const sortedStatuses = (selectedStatuses || []).sort(
    (a, b) => allPossibleStatuses.indexOf(a) - allPossibleStatuses.indexOf(b),
  );

  return (
    <div className="u-display-flex u-flexDirection-column">
      {sortedStatuses.map((status) => (
        <div key={`${keyPrefix}-${status}`}>
          <Chip
            className="u-margin-top-sm u-margin-right-sm"
            size="small"
            color="primary"
            label={statusDisplay(status)}
            onDelete={onRemove ? onRemove(status) : undefined}
          />
        </div>
      ))}
    </div>
  );
};
